export const hexurl = './data/uk-local-authority-districts-2021.hexjson';
export const dataurl = './data/pop-midyear-2020.csv';